import { Box, Grid } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import EmptyState from '../../../../components/EmptyState/EmptyState';
import { LANG_TEXT } from '../../../../constants/language';
import usePermission from '../../../../hooks/usePermission';
import { TabPanelProps } from '../../../../interfaces/index.types';
import { IOrders } from '../../order.types';
import Card from '../Card/Card';
import Loader from '../Loader/Loader';

export function ListOrder(
  props: TabPanelProps & {
    orderList: IOrders[];
    value: number;
    loading: boolean;
    toggleDrawer: (open: boolean) => void;
    openDrawer: boolean;
    showPreOrder: boolean;
    setSelectedOrder: React.Dispatch<React.SetStateAction<IOrders | undefined>>;
  }
) {
  const { t } = useTranslation();
  const { isAdminActionBlocked } = usePermission();

  return props.loading ? (
    <Loader />
  ) : props.orderList?.length > 0 ? (
    <Box sx={{ p: 3 }}>
      <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
        {props.orderList.map((item, index) => (
          <Grid
            sx={{ width: '100%' }}
            item
            sm={12}
            md={props.showPreOrder && isAdminActionBlocked ? 12 : props.showPreOrder ? 6 : 4}
            lg={props.showPreOrder && isAdminActionBlocked ? 12 : props.showPreOrder ? 6 : 4}
            xl={props.showPreOrder && isAdminActionBlocked ? 6 : props.showPreOrder ? 4 : 3}
            key={index}
          >
            <Card order={item} toggleDrawer={props.toggleDrawer} openDrawer={props.openDrawer} setSelectedOrder={props.setSelectedOrder} />
          </Grid>
        ))}
      </Grid>
    </Box>
  ) : (
    <EmptyState title={t(LANG_TEXT.EMPTY_NEW_ORDER)} />
  );
}
